module.exports = __webpack_public_path__ + "static/media/photo-1.b4379f22.jpg";